module.exports = __webpack_public_path__ + "media/images/logo-3e00717cfe3c9227465a77b3abfd46b9.png";